
import React from 'react';
import { Flex } from 'antd-mobile';
import logo from "../../style/imgs/invitation-page/logo.png";
import qrcod from "../../style/imgs/invitation-page/qrcod.png";
import defaultcover from "../../style/imgs/invitation-page/default.png";

class Headerfooter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const {evt} = this.props;
        return (
            <div>
                {this.props.type==='header' &&
                <div>
                    {evt.data.header.promoteLogo ? '':
                        <div className='common-header' style={{position:'fixed',top:0,zIndex:1000}}>
                            <Flex className='common-header-title' justify='between'>
                                <img onClick={()=>window.open('https://www.kancloud.cn/seven_qdj/qdj_help_201808/737970')} src={logo} alt=""/>
                                <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.xlzg.sign">下载APP</a>
                            </Flex>
                        </div>
                    }
                    <Flex wrap='wrap' className='common-banner'>
                        <div><img src={evt.data.header.banner ? evt.data.header.banner : defaultcover} alt=""/></div>
                        <div>{evt.data.header.name}</div>
                    </Flex>
                </div>
                }
                {this.props.type ==='footer' &&
                <div  className='qa-whitespace'>
                    {evt.data.header.promoteLogo ?
                        <div>
                            {evt.data.header.promoteLogo  == 'removed' && evt.data.header.promoteDesc  == 'removed' ? "" :
                                <div className='footer-container'>
                                    {evt.data.header.promoteLogo  == 'removed' ? '' :
                                        <div>
                                            <img src={evt.data.header.promoteLogo} alt=""/>
                                        </div>
                                    }
                                    <p>{evt.data.header.promoteDesc  == 'removed' ? '' : evt.data.header.promoteDesc}</p>
                                </div>}
                        </div>
                        :
                        <div className='footer-container'>
                            <div>
                                <img src={qrcod} alt=""/>
                            </div>
                            <p>长按识别二维码关注签到家</p>
                            <p>可以查看您报名、签到情况和接收最新资讯</p>
                        </div>
                    }
                </div>
                }
            </div>


        )
    }
}

Headerfooter.defaultProps = {
    type: '',

};
export default Headerfooter;



// WEBPACK FOOTER //
// ./src/containers/invitation-page/Headerfooter.jsx